import React from "react";
import {} from "../../../Redux/Actions/actions";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    videoChatLink: contactListData.videoChatLink,
  };
};
const VideoChat = (props) => {
  return (
    <div className="d-flex justify-content-center h-100 w-100">
      <iframe
        src={props.videoChatLink.link}
        style={{ width: "100vw", height: "90vh" }}
      ></iframe>
    </div>
  );
};

export default connect(mapStateToProps, {})(VideoChat);
